import React, { useRef, useState } from "react";

type PinInputProps = {
  value: string;
  onChange: (value: string) => void;
  onComplete?: (value: string) => void;
  disabled?: boolean;
  autoFocus?: boolean;
  slotClassName?: string;
};

const SLOTS = [0, 1, 2, 3, 4, 5];

const PinInput = ({
  value,
  onChange,
  onComplete,
  disabled = false,
  autoFocus = false,
  slotClassName = "h-12 w-10",
}: PinInputProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = event.target.value.replace(/\D/g, "").slice(0, 6);

    onChange(nextValue);

    if (nextValue.length === 6 && onComplete) onComplete(nextValue);
  };

  const activeIndex = Math.min(value.length, SLOTS.length - 1);

  return (
    <div
      onClick={() => inputRef.current?.focus()}
      className={`relative flex items-center gap-2 ${
        disabled ? "opacity-50" : ""
      }`}
    >
      <input
        ref={inputRef}
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={6}
        value={value}
        disabled={disabled}
        autoFocus={autoFocus}
        onChange={handleChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className="absolute inset-0 z-10 h-full w-full cursor-default opacity-0 disabled:cursor-not-allowed"
      />

      {SLOTS.map((index) => {
        const isActive = isFocused && !disabled && index === activeIndex;

        return (
          <div
            key={index}
            className={`relative flex items-center justify-center rounded-xl border-2 bg-white text-lg font-semibold text-[#113F67] transition-all duration-200 ${slotClassName} ${
              isActive
                ? "z-10 border-[#113F67] ring-2 ring-[#113F67]/30"
                : "border-gray-200"
            }`}
          >
            {value[index] || ""}
            {isActive && !value[index] && (
              <div className="absolute h-5 w-px animate-caret-blink bg-[#113F67] duration-1000"></div>
            )}
          </div>
        );
      })}
    </div>
  );
};
export default PinInput;
